/**
 * RateLockBadge — Compact header badge that shows the current LOCK/FLOAT
 * recommendation. Clicking it opens a modal with the full Rate Lock Advisor dashboard.
 */
import { Chip, CircularProgress, Tooltip } from '@mui/material';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import marketTrendApi from '../../../services/marketTrendApi';

const RateLockBadge = ({ onClick }) => {
  const { data, isLoading, error } =
    marketTrendApi.endpoints.getMarketTrends.useQuery(
      { loanCloseDays: 30 },
      { pollingInterval: 5 * 60 * 1000 }
    );

  const recommendation = data?.recommendation;

  if (isLoading && !recommendation) {
    return (
      <Chip
        size="small"
        icon={<CircularProgress size={12} />}
        label="Market..."
        onClick={onClick}
        sx={{ cursor: 'pointer', fontSize: '0.72rem' }}
      />
    );
  }

  if (error && !recommendation) {
    return (
      <Tooltip title="Rate Lock Advisor — click to view market analysis">
        <Chip
          size="small"
          icon={<ShowChartIcon sx={{ fontSize: 14 }} />}
          label="Market"
          onClick={onClick}
          sx={{ cursor: 'pointer', fontSize: '0.72rem' }}
        />
      </Tooltip>
    );
  }

  const isLock = recommendation?.recommendation === 'LOCK';
  const confidence = Math.round((recommendation?.confidenceScore || 0) * 100);

  const TrendIcon = recommendation?.treasuryTrend === 'UP'
    ? TrendingUpIcon
    : recommendation?.treasuryTrend === 'DOWN'
      ? TrendingDownIcon
      : TrendingFlatIcon;

  return (
    <Tooltip title={`Rate Lock Advisor: ${recommendation?.recommendation} (${confidence}% confidence) — ${recommendation?.explanation}`}>
      <Chip
        size="small"
        icon={isLock ? <LockIcon sx={{ fontSize: 14 }} /> : <LockOpenIcon sx={{ fontSize: 14 }} />}
        label={
          <>
            {isLock ? 'LOCK' : 'FLOAT'}
            <TrendIcon sx={{ fontSize: 12, ml: 0.5, opacity: 0.8, verticalAlign: 'middle' }} />
            <span style={{ marginLeft: 4, opacity: 0.7, fontSize: '0.65rem' }}>{confidence}%</span>
          </>
        }
        onClick={onClick}
        color={isLock ? 'error' : 'success'}
        variant="outlined"
        sx={{ cursor: 'pointer', fontSize: '0.72rem' }}
      />
    </Tooltip>
  );
};

export default RateLockBadge;
